module.exports = require("react-truncate-markup/lib");